import React from "react";
import { Spinner } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, useLocation } from "react-router-dom";
import { auth } from "../../../firebase.init";
import EmailVerified from "./EmailVarified/EmailVarified";

const RequireAuth = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  let location = useLocation();
  if (loading) {
    return <Spinner className="ml-50" animation="border" variant="success" />;
  }
  if (user?.providerData[0]?.providerId === "password" && !user.emailVerified) {
    return <EmailVerified></EmailVerified>;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  };
  return children;
};

export default RequireAuth;
